import { render, staticRenderFns } from "./product-case.vue?vue&type=template&id=6a8b184b&scoped=true&"
import script from "./product-case.vue?vue&type=script&lang=js&"
export * from "./product-case.vue?vue&type=script&lang=js&"
import style0 from "./product-case.vue?vue&type=style&index=0&id=6a8b184b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b184b",
  null
  
)

export default component.exports